import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function ProjectEngagementUserReducer(state = initialState.projectEngagementsUsers, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_CONTACT_DETAILS: {
			return action.response;
        }
        case types.CLEAR_ENGAGEMENT_CONTAC_DETAILS: {
			return initialState.projectEngagementsUsers;
		}
		default:
			return state;
	}
}
